// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pb","tag":"pc","isRental":"pd","title":"pe","title2":"pf","description":"ph","cta":"pi","ratingLabel":"pj","ratingLabelSmallScreen":"pk","iconInHotspotVideo":"pl"};